/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { CustomTaskStepOverrideTaskNoteDoc } from './customTaskStepOverrideTaskNoteDoc';

export interface CustomTaskStepOverride {
  type: 'custom_task';
  task_note_doc?: CustomTaskStepOverrideTaskNoteDoc;
}
